// ISS-285582: Constants for the Asset Management feature.
// Backend HLD: projectx → sdd/ISS-285582/HLD_v2.md

export const ASSET_MANAGEMENT_ROUTE_PATH = '/asset-management';

export const TAB_KEY = {
  ALL_ASSIGNMENTS: 'assignments',
  MANAGE_ASSETS: 'assets',
  HUB_CONFIGS: 'hub-configs',
} as const;

export type TabKey = typeof TAB_KEY[keyof typeof TAB_KEY];

export const TAB_QUERY_PARAM = 'tab';

// Allocation status — backend values used verbatim per FE-HLD §4 (Q4).
export const ALLOCATION_STATUS = {
  INITIATED: 'initiated',
  ALLOCATED: 'allocated',
  CANCELLED: 'cancelled',
} as const;

export type AllocationStatus = typeof ALLOCATION_STATUS[keyof typeof ALLOCATION_STATUS];

// Default empty redux slice shapes — reused across mapStateToProps fallbacks.
export const EMPTY_LIST_SLICE = {
  isLoading: false,
  data: [] as never[],
  error: null as string | null,
};

export const EMPTY_ALLOCATIONS_SLICE = {
  isLoading: false,
  data: [] as never[],
  count: 0,
  error: null as string | null,
};

// Redux action types.
export const SET_ACTIVE_TAB = 'AssetManagement/SET_ACTIVE_TAB';
export const FETCH_ASSETS_REQUEST = 'AssetManagement/FETCH_ASSETS_REQUEST';
export const FETCH_ASSETS_SUCCESS = 'AssetManagement/FETCH_ASSETS_SUCCESS';
export const FETCH_ASSETS_FAILURE = 'AssetManagement/FETCH_ASSETS_FAILURE';
export const FETCH_HUB_MAPPINGS_REQUEST = 'AssetManagement/FETCH_HUB_MAPPINGS_REQUEST';
export const FETCH_HUB_MAPPINGS_SUCCESS = 'AssetManagement/FETCH_HUB_MAPPINGS_SUCCESS';
export const FETCH_HUB_MAPPINGS_FAILURE = 'AssetManagement/FETCH_HUB_MAPPINGS_FAILURE';
export const FETCH_ALLOCATIONS_REQUEST = 'AssetManagement/FETCH_ALLOCATIONS_REQUEST';
export const FETCH_ALLOCATIONS_SUCCESS = 'AssetManagement/FETCH_ALLOCATIONS_SUCCESS';
export const FETCH_ALLOCATIONS_FAILURE = 'AssetManagement/FETCH_ALLOCATIONS_FAILURE';
